module.exports = __webpack_public_path__ + "img/serviceKiosk.21117543.gif";